// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2u4kY","controls":"styles_controls__QADxS","charLimit":"styles_charLimit__2HmQF","input":"styles_input__2WZif","send":"styles_send__2pAdA"};